import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getList() {
    return axiosIns.get('/admin/report_sections')
  },
  create(params) {
    return axiosIns.post('/admin/report_sections', { report_section: snakecaseKeys(params) })
  },
  update(id, params) {
    return axiosIns.patch(`/admin/report_sections/${id}`, { report_section: snakecaseKeys(params) })
  },
  destroy(id) {
    return axiosIns.delete(`/admin/report_sections/${id}`)
  },
  updatePositions(params) {
    return axiosIns.patch('/admin/report_sections/update_positions', snakecaseKeys(params))
  },
}
